export const MFA_REQUIRED = "MFA_REQUIRED"